import { render } from "./SkyTableHead.vue?vue&type=template&id=c47204d6"
import script from "./SkyTableHead.vue?vue&type=script&lang=js"
export * from "./SkyTableHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__